module.exports = __webpack_public_path__ + "img/filomeno-fired.080aa99d.png";